var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBItcoinCurrency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    width: 96,
    height: 64,
    rx: 8,
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4018 36.8368C64.7296 47.5568 53.8685 54.0733 43.1638 51.401C32.4435 48.7288 25.927 37.8682 28.5993 27.1637C31.2715 16.4437 42.1168 9.9271 52.8371 12.5994C63.5418 15.256 70.0742 26.1166 67.4018 36.8368Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5231 29.5081C57.9138 26.8518 55.8981 25.4143 53.1169 24.4612L54.0231 20.8518L51.8356 20.3049L50.9606 23.8206C50.3825 23.6799 49.7888 23.5393 49.195 23.4143L50.07 19.8831L47.8825 19.3362L46.9919 22.9299C46.5075 22.8206 46.0388 22.7112 45.5856 22.6018V22.5862L42.5544 21.8362L41.9763 24.1799C41.9763 24.1799 43.6013 24.5549 43.57 24.5706C44.4606 24.7893 44.6169 25.3831 44.5856 25.8518L43.5544 29.9612C43.6169 29.9768 43.695 29.9924 43.7888 30.0393C43.7106 30.0237 43.6325 30.0081 43.5544 29.9768L42.1169 35.7268C42.0075 35.9924 41.7263 36.3987 41.1169 36.2424C41.1325 36.2737 39.5231 35.8518 39.5231 35.8518L38.4294 38.3674L41.2888 39.0862C41.82 39.2268 42.3356 39.3518 42.8513 39.4924L41.945 43.1331L44.1325 43.6799L45.0388 40.0706C45.6325 40.2268 46.2263 40.3831 46.7888 40.5237L45.8981 44.1174L48.0856 44.6643L48.9919 41.0237C52.7419 41.7268 55.5544 41.4456 56.7263 38.0549C57.6794 35.3362 56.6794 33.7581 54.7106 32.7268C56.1638 32.3987 57.2419 31.4456 57.5231 29.5081ZM52.5075 36.5393C51.8356 39.2581 47.2419 37.7893 45.7575 37.4143L46.9606 32.5862C48.445 32.9612 53.2263 33.6956 52.5075 36.5393ZM53.195 29.4612C52.57 31.9456 48.7575 30.6799 47.5231 30.3674L48.6169 25.9924C49.8513 26.3049 53.8356 26.8831 53.195 29.4612Z",
    fill: "#0D0D2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(28 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBItcoinCurrency);
export default __webpack_public_path__ + "static/media/BItcoinCurrency.63250dc5f458b780f44191b05ed385f1.svg";
export { ForwardRef as ReactComponent };